require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconBook.tsx
var IconBook_exports = {};
__export(IconBook_exports, {
  default: () => IconBook_default
});
module.exports = __toCommonJS(IconBook_exports);

// src/assets/monochrome/book.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgBook = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.4825 2.70596C16.7881 1.64821 15.3868 1.07701 13.9896 1.10081C12.7552 1.12184 11.6328 1.60541 10.4231 2.3865C9.0879 1.60389 7.85334 1.12175 6.49802 1.10081C4.96581 1.07713 3.42593 1.64512 1.55786 2.70266C1.27474 2.86294 1.09961 3.16272 1.09961 3.48778V17.9974C1.09961 18.3103 1.262 18.6007 1.52853 18.7652C1.79501 18.9296 2.12777 18.9447 2.40812 18.8052C4.1356 17.9456 5.33243 17.5558 6.41701 17.5438C7.47757 17.5321 8.55142 17.8819 10.0276 18.7703C10.3069 18.9385 10.6554 18.9435 10.9395 18.7836C11.0745 18.7076 11.1851 18.5999 11.2639 18.4728C12.3698 17.8016 13.2223 17.5336 14.0632 17.5438C15.04 17.5557 16.121 17.9429 17.6874 18.8024C17.9495 18.9462 18.2618 18.9301 18.5096 18.7615C18.7556 18.5942 18.8996 18.3037 18.8996 17.9974V3.48778C18.8996 3.16968 18.7443 2.86939 18.4825 2.70596ZM2.90904 16.5828L2.90904 4.02052C4.43205 3.20655 5.51289 2.89118 6.47 2.90597C7.40879 2.92047 8.3474 3.25426 9.59018 3.99254V16.4882C8.50652 15.9871 7.48125 15.7266 6.39701 15.7385C5.27121 15.751 4.15037 16.0573 2.90904 16.5828ZM14.0159 2.90597C14.8763 2.8913 15.8514 3.20365 17.2308 4.01632L17.2308 16.5736C16.1134 16.0545 15.1007 15.7509 14.0819 15.7385C13.169 15.7274 12.3027 15.9501 11.3996 16.3799V3.85982C12.4273 3.21233 13.2228 2.91948 14.0159 2.90597Z", fill: "#676F7E" }) });
var book_default = SvgBook;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconBook.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconBook = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(book_default, {}) });
};
IconBook.displayName = "IconBook";
var IconBook_default = IconBook;
